import type { ShiftRQSchema } from '@libs/data-access/queries'
import { IconWrap, MealIcon } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import React from 'react'
import type { FC } from 'react'

import { Note } from '../../../../components'
import { BreakCol } from '../../../../components/BreakCol/BreakCol'
import { MealCol, hasMealsToShow } from '../../../../components/MealCol/MealCol'
import { useReactBlockHoursStyles } from '../../../../hooks/useReactBlockHoursStyles'
import styles from '../BlockHoursInfo.module.css'

type Props = {
  shift: ShiftRQSchema
  color?: string
  shiftIsFinishedWithoutOut: boolean
}
export const PlannedCard: FC<Props> = ({
  color,
  shift,
  shiftIsFinishedWithoutOut
}) => {
  const { t, tDates } = usePlanningFormTranslation()

  const reactBlockStyle = useReactBlockHoursStyles({ color })
  const hasPlannedMeal = hasMealsToShow(shift.shift_meals, 'planned')

  const totalBreakTime =
    shift.shift_breaks?.length > 0
      ? shift.shift_breaks?.reduce(
          (accumulator, breakItem) =>
            (accumulator ?? 0) + (breakItem?.planned_duration ?? 0),
          0
        )
      : 0

  const getTotalMeal = shift.shift_meals.reduce(
    (acc, nextValue) =>
      (acc ?? 0) +
      Number(
        nextValue?.planned_meal_type !== null &&
          nextValue?.planned_meal_type !== 'NT'
      ),
    0
  )

  const rangeDates = tDates('range.shortHourMinuteDashed', {
    start: shift.starts_at,
    end: shift.ends_at
  })

  return (
    <div className={styles.BreakRow} id='planned-card'>
      <div className={styles.TitleCard}>
        {t('shiftRealHoursForm.plannedCard.title')}
      </div>
      <div className={styles.BreakCol}>
        <div className={styles.BadgeAndHours}>
          <span style={reactBlockStyle} />
          {t('shiftRealHoursForm.common.breakTime', {
            range: rangeDates,
            total: totalBreakTime,
            size: hasPlannedMeal ? getTotalMeal : ''
          })}
          {hasPlannedMeal && <IconWrap icon={<MealIcon />} />}
        </div>
        {totalBreakTime !== 0 && (
          <div className={styles.CardSubPart}>
            <BreakCol
              breaks={shift.shift_breaks}
              size={shift.shift_breaks.length}
              type='planned'
              shiftIsFinishedWithoutOut={shiftIsFinishedWithoutOut}
            />
          </div>
        )}
        {hasPlannedMeal && (
          <div className={styles.CardSubPart}>
            <MealCol meals={shift.shift_meals} scheduleType='planned' />
          </div>
        )}
        {Boolean(shift?.note) && (
          <div className={styles.CardSubPart}>
            <Note note={shift.note} />
          </div>
        )}
      </div>
    </div>
  )
}
